import { createLanguageRegistrar } from "./languageBase";

/** Monarch language definition for Bash/Shell. */
const bashDef: Record<string, unknown> = {
  keywords: [
    "if",
    "then",
    "else",
    "elif",
    "fi",
    "for",
    "in",
    "do",
    "done",
    "while",
    "until",
    "case",
    "esac",
    "function",
    "select",
    "return",
    "exit",
    "break",
    "continue",
    "local",
    "declare",
    "typeset",
    "export",
    "readonly",
    "unset",
    "shift",
    "source",
    "eval",
    "exec",
    "trap",
  ],

  builtins: ["echo", "printf", "read", "cd", "pwd", "pushd", "popd", "dirs", "let", "test", "set", "true", "false"],

  tokenizer: {
    root: [
      [/^#![^\n]*/, "comment.bash"],
      [/#[^\n]*/, "comment.bash"],
      [/<<-?\s*['"]?(\w+)['"]?/, "string.heredoc.bash"],
      [/"/, "string.bash", "@doubleString"],
      [/'/, "string.bash", "@singleString"],
      [/`/, "string.bash", "@backtick"],
      [/\$\{/, "variable.bash", "@variableExpansion"],
      [/\$\(/, "variable.bash", "@commandSubstitution"],
      [/\$[a-z_]\w*/i, "variable.bash"],
      [/\$[0-9@#?!*$-]/, "variable.bash"],
      [/\b0x[0-9a-f]+\b/i, "number.bash"],
      [/\b\d+\b/, "number.bash"],
      [
        /[a-z_]\w*/i,
        {
          cases: {
            "@keywords": "keyword.bash",
            "@builtins": "predefined.bash",
            "@default": "identifier",
          },
        },
      ],
      [/\|\||&&/, "keyword.operator.bash"],
      [/[|;&]/, "delimiter"],
      [/[<>]+/, "operator.bash"],
      [/\[\[|\]\]/, "keyword.bash"],
      [/[=()[\]]/, "delimiter"],
      [/[*?]/, "operator.bash"],
      [/\s+/, "white"],
    ],

    doubleString: [
      [/\$\{/, "variable.bash", "@variableExpansion"],
      [/\$\(/, "variable.bash", "@commandSubstitution"],
      [/\$[a-z_]\w*/i, "variable.bash"],
      [/\$[0-9@#?!*$-]/, "variable.bash"],
      [/[^\\"$]+/, "string.bash"],
      [/\\./, "string.escape.bash"],
      [/"/, "string.bash", "@pop"],
    ],

    singleString: [
      [/[^']+/, "string.bash"],
      [/'/, "string.bash", "@pop"],
    ],

    backtick: [
      [/[^\\`]+/, "string.bash"],
      [/\\./, "string.escape.bash"],
      [/`/, "string.bash", "@pop"],
    ],

    variableExpansion: [
      [/\}/, "variable.bash", "@pop"],
      [/[a-z_]\w*/i, "variable.bash"],
      [/./, "variable.bash"],
    ],

    commandSubstitution: [
      [/\)/, "variable.bash", "@pop"],
      [/./, "identifier"],
    ],
  },
};

/**
 * Registers a Monarch tokenizer for Bash/Shell with Monaco.
 */
export const registerBash = createLanguageRegistrar(
  { id: "bash", extensions: [".sh", ".bash", ".zsh"], aliases: ["shell", "sh"] },
  bashDef,
);
